export default __webpack_public_path__ + "static/media/Check_sq-fr.f2fb5ab0.svg";